import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AuthAlert, AuthPageLayout } from '../../auth/components/AuthPageLayout';
import { Spinner } from '../../../shared/components';
import { buildWorkspaceUrl } from '../../../shared/config/workspaceHost';
import styles from './WorkspacePicker.module.css';

/**
 * Convenience resolver for `/w/{slug}`: it forwards to the workspace hostname rather than serving
 * the workspace itself, so tenancy stays host-based everywhere else in the app.
 */
export const WorkspaceSlugRedirect: React.FC = () => {
  const { t } = useTranslation('workspaces');
  const { slug } = useParams<{ slug: string }>();
  const target = slug ? buildWorkspaceUrl(slug) : null;

  React.useEffect(() => {
    if (target) {
      window.location.replace(target);
    }
  }, [target]);

  if (!target) {
    return (
      <AuthPageLayout title={t('redirect.title')}>
        <AuthAlert variant="error">{t('redirect.unavailable')}</AuthAlert>
      </AuthPageLayout>
    );
  }

  return (
    <AuthPageLayout title={t('redirect.title')} subtitle={t('redirect.subtitle', { slug })}>
      <div className={styles.status}>
        <Spinner size={36} text={t('redirect.working')} />
      </div>
    </AuthPageLayout>
  );
};

export default WorkspaceSlugRedirect;
